export const qrScanner = {
  redirectedTo: '你將會被跳轉至{{message}}',
}
